import { Link } from "react-router-dom";
import { Mail } from "lucide-react";
import { AUTHOR_EMAIL, AUTHOR_NAME, AUTHOR_SITE, PRODUCT_NAME } from "../../lib/site";

export const Footer = () => (
  <footer
    data-testid="footer"
    className="bg-choc px-6 pb-32 pt-16 text-cream sm:px-10 md:pb-12 lg:px-16"
  >
    <div className="mx-auto grid max-w-6xl gap-12 md:grid-cols-[1.4fr_1fr_1fr]">
      <div>
        <span className="font-display text-xl italic">{PRODUCT_NAME}</span>
        <p className="mt-4 max-w-sm text-sm leading-relaxed text-cream/60">
          Komplet dokumentów prawnych dla restauracji, barów i kawiarni.
          Sanepid, PIP, RODO i rezerwacje — w jednym pakiecie.
        </p>
        <p className="mt-5 text-sm text-cream/75">
          Autorka pakietu: <span className="font-semibold text-cream">{AUTHOR_NAME}</span>, prawnik i doktorantka ·{" "}
          <a
            data-testid="footer-author-site-link"
            href={AUTHOR_SITE}
            target="_blank"
            rel="noopener noreferrer"
            className="text-brick-soft underline-offset-2 transition-colors duration-300 hover:text-white hover:underline"
          >
            prawodorzeczy.pl
          </a>
        </p>
      </div>
      <div>
        <h3 className="text-xs font-semibold uppercase tracking-[0.25em] text-cream/50">Kontakt</h3>
        <a
          data-testid="footer-email-link"
          href={`mailto:${AUTHOR_EMAIL}`}
          className="mt-4 inline-flex items-center gap-2 text-sm text-cream/85 transition-colors duration-300 hover:text-white"
        >
          <Mail className="h-4 w-4 text-brick-soft" />
          {AUTHOR_EMAIL}
        </a>
      </div>
      <div>
        <h3 className="text-xs font-semibold uppercase tracking-[0.25em] text-cream/50">
          Informacje prawne
        </h3>
        <ul className="mt-4 space-y-2.5 text-sm">
          <li>
            <Link
              data-testid="footer-privacy-link"
              to="/polityka-prywatnosci"
              className="text-cream/85 transition-colors duration-300 hover:text-white"
            >
              Polityka prywatności
            </Link>
          </li>
          <li>
            <Link
              data-testid="footer-terms-link"
              to="/regulamin"
              className="text-cream/85 transition-colors duration-300 hover:text-white"
            >
              Regulamin sklepu
            </Link>
          </li>
        </ul>
      </div>
    </div>
    <div className="mx-auto mt-14 flex max-w-6xl flex-col gap-3 border-t border-cream/10 pt-7 text-xs text-cream/45 sm:flex-row sm:items-center sm:justify-between">
      <span data-testid="footer-copyright">© 2026 {AUTHOR_NAME} · {PRODUCT_NAME}. Wszelkie prawa zastrzeżone.</span>
      <span>Dokumenty są wzorami do samodzielnego uzupełnienia i nie stanowią indywidualnej porady prawnej.</span>
    </div>
  </footer>
);
